export const formatDate = (value) => {
  const date = new Date(value)

  const formatter = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })

  return formatter.format(date).replace(/\./g, '/')
}